import React from 'react';
import { Image, Text, View } from 'react-native';
import { getSubCategoryId } from '../../utils/DictionaryManagementUtils';
import { getServiceImageByKey } from '../../utils/ImagesManagementUtils';

//= ========================================================================

const ServiceBtnLayout = ({
  globJSON, service, isBars, isRound, multi = 1,
}) => {
  const textId = getSubCategoryId(service);
  const spaceInRow = '33.333333%';
  const { colors } = globJSON.configurations.theme;

  const styles = {
    serviceContainerRound: {
      marginBottom: multi * 10,
      alignItems: 'center',
      flexBasis: spaceInRow,
    },
    serviceContainerBars: {
      marginBottom: multi * 10,
      boxShadow: `0 0 ${multi * 4}px 0 rgba(0, 0, 0, 0.1)`,
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: colors.app_background_color,
      borderRadius: globJSON.configurations.theme.radius.elements_shape_square ? multi * 3 : multi * 9,
      border: `solid  ${multi}px ${colors.border_color}`,
      overflow: 'hidden',
    },
    serviceIconRound: {
      width: multi * 47,
      height: multi * 47,
      borderRadius: multi * (isRound ? 47 : 3),
      boxShadow: `0 0 ${multi * 4}px 0 rgba(0, 0, 0, 0.1)`,
      marginBottom: (multi ** 0.5) * 3,
    },
    serviceIconBars: {
      width: multi * 40,
      height: multi * 40,
    },
    headlineRound: {
      width: multi * 70,
      fontSize: multi * 8,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      wordWrap: 'break-word',
      textAlign: 'center',
      color: colors.primary_font_color,
    },
    headlineBars: {
      color: colors.primary_font_color,
      marginStart: multi * 4,
      fontSize: multi * 12,
    },
  };

  return (
    <View style={isBars ? styles.serviceContainerBars : styles.serviceContainerRound}>
      <Image
        fadeDuration={0}
        style={isBars ? styles.serviceIconBars : styles.serviceIconRound}
        source={getServiceImageByKey(globJSON, textId, service.sub_category)}
      />
      <Text style={isBars ? styles.headlineBars : styles.headlineRound}>{service.name}</Text>
    </View>
  );
};
export default ServiceBtnLayout;
